import api from './axios';

const userService = {
  getAll: (params = {}) => {
    return api.get('/user', { params });
  },

  getById: (id) => {
    return api.get(`/user/${id}`);
  },

  create: (data) => {
    return api.post('/user', data);
  },

  update: (id, data) => {
    return api.put(`/user/${id}`, data);
  },

  delete: (id) => {
    return api.delete(`/user/${id}`);
  },

  changePassword: (email, currentPassword, newPassword) => {
    return api.post('/user/change-password', { email, currentPassword, newPassword });
  },
};

export default userService;
